// extracted by mini-css-extract-plugin
module.exports = {"tablaGen":"style_tablaGen__3fvow","fila":"style_fila__2Biaq","col":"style_col__1HzJk","hiddenTable":"style_hiddenTable__178Ra"};